import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const CheckCircleFilled = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4ZM9.00564 16.3293L13.3651 20.7024C13.6013 20.9399 13.9832 20.948 14.2294 20.7224L22.9738 12.6974C23.2281 12.4637 23.245 12.0687 23.0119 11.8143L22.5619 11.3237C22.3288 11.0693 21.9332 11.0524 21.6788 11.2855L14.2888 18.0674C14.0419 18.2937 13.6607 18.2855 13.4238 18.048L10.3625 14.9768C10.1188 14.7324 9.72319 14.7318 9.47882 14.9755L9.00694 15.4455C8.76256 15.6893 8.76189 16.0849 9.00564 16.3293Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default CheckCircleFilled
